<script lang="ts">
  import { fetchCartCount$ } from "$lib/serv/core/auth";
</script>

{#if $fetchCartCount$ > 0}
	<div class="navLoader"></div>
{/if}

<style lang="scss">
	@use 'screen';
	@use 'color';

	@keyframes spin {
		100% { transform: rotate(360deg) }
	}

	.navLoader {
		width: 44px;
    height: 44px;
    border-radius: 15px;
    background: color.$background-elevation-12dp;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
		&:before {
			content: "";
      position: absolute;
      width: 100px;
      height: 100px;
      background-image: conic-gradient(color.$primary-variant 20deg, transparent 120deg);
      animation: spin 2s linear infinite;
		}
		&:after {
			content: '';
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 13px;
      background: color.$background-elevation-12dp;
		}
		@media(screen.$md) {
			width: 112px;
    	height: 42px;
			border-radius: 25px;
			&:before {
				width: 220px;
      	height: 220px;
			}
			&:after {
				width: 108px;
				height: 38px;
				border-radius: 23px;
			}
		}
	}
</style>